import { getExtensionFromFileName } from 'owa-file';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import { isImageFile } from 'owa-file';
import getAttachmentThumbnailUrl from 'owa-attachment-model-store/lib/utils/getAttachmentThumbnailUrl';
import { isCloudyAttachmentType } from 'owa-attachment-model-store/lib/utils/isCloudyAttachment';
import { lazyPrint } from 'owa-printableiframe-view';
import { getAttachmentUrl } from 'owa-attachment-url';
import { AttachmentUrlType } from 'owa-files-url';
import { ClientAttachmentId } from 'owa-client-ids';

export async function print(itemId: ClientAttachmentId, attachment: AttachmentType) {
    const fileExtension = getExtensionFromFileName(attachment.Name);
    if (fileExtension.toLowerCase() === '.pdf') {
        const printUrl = getAttachmentUrl(
            itemId,
            attachment,
            AttachmentUrlType.Print,
            false,
            false
        );
        window.open(printUrl, '_blank');
    } else if (isImageFile(attachment.Name)) {
        const url = await getAttachmentThumbnailUrl(
            itemId,
            attachment,
            isCloudyAttachmentType(attachment)
        );
        lazyPrint.importAndExecute(getPrintableImageHtmlString(url), getImageCSSString());
    }
}

export function getPrintableImageHtmlString(url: string): string {
    const div = document.createElement('div');
    const img = document.createElement('img');
    img.src = url;
    div.appendChild(img);
    return div.innerHTML;
}

export function getImageCSSString(): string {
    const imagecss = 'img {max-width: 100%; max-height: 100%; width: auto;  }';
    return imagecss;
}
